/**
 * Converts a currency amount from major units (e.g., dollars) to minor units (e.g., cents)
 *
 * @param amount - The amount in major currency units (e.g., 2000.00 for $2000.00)
 * @returns The amount in minor currency units (e.g., 200000 for $2000.00)
 */
export function convertToMinorCurrencyUnits(amount: number): number {
  return Math.round(amount * 100)
}

/**
 * Converts a currency amount from minor units (e.g., cents) to major units (e.g., dollars)
 *
 * @param amount - The amount in minor currency units (e.g., 200000 for $2000.00)
 * @returns The amount in major currency units (e.g., 2000.00 for $2000.00)
 */
export function convertToMajorCurrencyUnits(amount: number): number {
  return amount / 100
}
